import React, { FC } from 'react';
import { FaTimes } from 'react-icons/fa';
import Typography from 'components/common/Typography';
import { CloseButton } from './ModalHeader.style';

interface ModalHeaderType {
  title?: string;
  closeModal?: (any) => void;
  textAlign?: 'center' | 'left' | 'right' | 'justify';
}

const { Title } = Typography;
const ModalHeader: FC<ModalHeaderType> = ({ title, closeModal, textAlign }) => {
  return (
    <>
      {!!closeModal && (
        <CloseButton type='button' onClick={closeModal}>
          <FaTimes />
        </CloseButton>
      )}
      {title && (
        <Title
          data-test-modal-title
          level={1}
          strong='true'
          textAlign={textAlign}>
          {title}
        </Title>
      )}
    </>
  );
};

export default ModalHeader;
